<template>
  <v-img :src="proxyMedia.url" :srcset="proxyMedia.srcset" v-bind="$attrs" v-on="$listeners">
    <slot />
  </v-img>
</template>

<script>
export default {
  name: "TkMedia",

  props: ["media", "disableIntersection"],

  data: () => ({
    observer: null,
    intersected: false,
  }),

  computed: {
    proxyMedia() {
      return this.intersected || this.disableIntersection ? this.media : {};
    },
  },
  mounted() {
    if (!!window.IntersectionObserver) {
      this.observer = new IntersectionObserver((entries) => {
        const image = entries[0];
        if (image.isIntersecting) {
          this.intersected = true;
          this.observer.disconnect();
        }
      });

      this.observer.observe(this.$el);
    } else {
      this.intersected = true;
    }
  },
  destroyed() {
    this.observer.disconnect();
  },
};
</script>